import React, { useState, useEffect } from 'react';
import { Button, Form, Container, Card, Row, Col, Spinner, Alert } from 'react-bootstrap';
import axios from 'axios';
import ReceiptsTable from './ReceiptsTable';
import { useApi } from './ApiContext';

const ReceiptsPage = ({ token }) => {
  const [sDate, setStartDate] = useState('');
  const [eDate, setEndDate] = useState('');
  const [receipts, setReceipts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { baseUrl } = useApi();

  useEffect(() => {
    const today = new Date();
    const last7Days = new Date(today);
    last7Days.setDate(today.getDate() - 7);

    setStartDate(last7Days.toISOString().split('T')[0]);
    setEndDate(today.toISOString().split('T')[0]);

    fetchReceipts(last7Days.toISOString().split('T')[0], today.toISOString().split('T')[0]);
  }, []);

  const fetchReceipts = async (startDate, endDate) => {
    setLoading(true);
    setError('');

    try {
      const response = await axios.post(
        `${baseUrl}/api/report/GetReceiptbyDate`,
        { sDate: startDate, eDate: endDate },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setReceipts(response.data.data || []);
    } catch (err) {
      const errorMessage =
        err.response?.data?.message || err.message || 'Failed to fetch receipts. Please try again.';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleFetchReceipts = () => {
    fetchReceipts(sDate, eDate);
  };

  const handleFetchCurrentMonth = () => {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().split('T')[0];
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0).toISOString().split('T')[0];

    setStartDate(firstDay);
    setEndDate(lastDay);

    fetchReceipts(firstDay, lastDay);
  };

  return (
    <Container className="mt-5">
      <Card>
        <Card.Body>
          <Card.Title>Receipts</Card.Title>
          <Form>
            {/* Date Input Row */}
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Start Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={sDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>End Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={eDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* Buttons Row */}
            <Row>
              <Col className="d-flex justify-content-end">
                <Button className="me-2" onClick={handleFetchReceipts} disabled={loading}>
                  {loading ? <Spinner as="span" animation="border" size="sm" /> : 'Fetch'}
                </Button>
                <Button variant="secondary" onClick={handleFetchCurrentMonth}>
                  Current Month
                </Button>
              </Col>
            </Row>
          </Form>

          {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
        </Card.Body>
      </Card>

      {/* Display receipts table */}
      <ReceiptsTable receipts={receipts} />
    </Container>
  );
};

export default ReceiptsPage;
